import { SxProps, Theme } from '@mui/system';

const style = {
  container: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: '12px',
    padding: '0px 16px 0 16px',
    alignItems: 'center',
  },
  headerContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  title: {
    fontSize: 18,
    fontWeight: 600,
    marginLeft: '16px',
  },
  selectHeader: { marginRight: '8px' },
} satisfies Record<string, SxProps<Theme>>;

export default style;
